import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function Waste({
  size = sizes.MEDIUM,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="-1 0 20 18"
      {...props}
    >
      <g fill={colour} fillRule="evenodd">
        <path d="M4.25298 5.05216C4.06131 4.93549 3.99465 4.67716 4.11131 4.48549L5.08631 2.86049L5.94465 1.43549C6.26965 0.893823 7.05298 0.893823 7.37798 1.43549L8.61131 3.48549L7.58631 5.20216L6.98631 6.20216C6.85298 6.39382 6.59465 6.46049 6.39465 6.34382L4.25298 5.05216ZM17.1863 9.68549L16.0696 7.81882C15.953 7.62716 15.703 7.56049 15.503 7.66882L13.3363 8.91882C13.1363 9.03549 13.0696 9.29382 13.1863 9.49382L14.8113 12.2105H15.7196C16.228 12.2105 16.7196 11.9938 17.0446 11.6022C17.2946 11.2938 17.4196 10.9188 17.4196 10.5438C17.4196 10.2438 17.3363 9.95216 17.1863 9.68549ZM12.4196 16.3772H13.6696C14.303 16.3772 14.878 16.0188 15.1613 15.4522L16.3696 13.0438H12.4196V12.3855C12.4196 12.0105 11.9696 11.8272 11.7113 12.0938L9.38631 14.4188C9.21965 14.5855 9.21965 14.8438 9.38631 15.0105L11.7113 17.3355C11.9696 17.5938 12.4196 17.4105 12.4196 17.0438V16.3772ZM7.00298 13.0438H3.83631L3.13631 14.2188C2.88631 14.6355 2.86965 15.1522 3.08631 15.5938C3.31965 16.0688 3.81131 16.3772 4.35298 16.3772H7.00298C7.23631 16.3772 7.41965 16.1938 7.41965 15.9605V13.4605C7.41965 13.2272 7.23631 13.0438 7.00298 13.0438ZM4.18631 10.8355L4.76965 11.1855C5.08631 11.3772 5.47798 11.0855 5.38631 10.7272L4.58631 7.52716C4.53631 7.31049 4.31131 7.16882 4.08631 7.22716L0.894648 8.02716C0.536314 8.11882 0.461314 8.59382 0.777981 8.78549L1.32798 9.11882L0.986314 9.69382C0.694647 10.1855 0.669647 10.7855 0.927981 11.2938L2.28631 14.0105L4.18631 10.8355ZM13.2696 3.16049L12.1863 1.35216C11.878 0.852157 11.3363 0.543823 10.753 0.543823H7.81131L10.4113 4.87716L9.83631 5.21882C9.51965 5.41049 9.58631 5.89382 9.95298 5.97716L13.1446 6.77716C13.3696 6.83549 13.5946 6.69382 13.653 6.47716L14.453 3.28549C14.5446 2.92716 14.153 2.63549 13.8363 2.82716L13.2696 3.16049Z" />
      </g>
    </svg>
  )
}

Waste.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
